import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import TableWithPagination from "./TableWithPagination";
const Header = styled(DialogTitle)`
  background-color: #28929c;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`;

const Content = styled(DialogContent)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
  background-color: #2b3342;
  color: white;
`;

const Footer = styled(DialogActions)`
  background-color: #28929c;
  padding: 10px;
  font-size: 14px;
`;

const UserAuditHistory = ({
  open,
  onClose,
  user,
  auditHistory,
  totalRecords,
  page,
  limit,
  onPageChange,
  onLimitChange,
  isLoading,
}) => {
  const columns = [
    { id: "uuid", label: "ID", display: "hidden" },
    { id: "date", label: "Date" },
    { id: "user", label: "User" },
    { id: "action", label: "Action" },
  ];

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg">
      <Header>
        Audit History - {user?.first_name} {user?.last_name}
        <IconButton onClick={onClose} style={{ color: "white" }}>
          <CloseIcon />
        </IconButton>
      </Header>
      <Content>
        <TableWithPagination
          title="User Audit History"
          columns={columns}
          rows={auditHistory}
          totalRecords={totalRecords}
          page={page}
          limit={limit}
          onPageChange={onPageChange}
          onLimitChange={onLimitChange}
          noSearch={true}
          isLoading={isLoading}
        />
      </Content>
      <Footer>
        <DialogActions>
          <Button onClick={onClose} color="primary" variant="contained">
            Close
          </Button>
        </DialogActions>
      </Footer>
    </Dialog>
  );
};

export default UserAuditHistory;
